/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Amount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputCurrency from 'DesignSystem/TysiaInput/TysiaInputCurrency/index'



/** @type {import('Simple/types.js').View} */
export default function Amount({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/EditRules/Value/Amount",
  onChange
  
}) {
let rulesetCustomPaymentPlanRulesetMinDownpaymentValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.min_downpayment',
})
let rulesetCustomPaymentPlanRulesetMinDownpaymentChangeData = fromData.useDataChange({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.min_downpayment',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="ruleset.custom_payment_plan_ruleset.min_downpayment"
 value={rulesetCustomPaymentPlanRulesetMinDownpaymentValueData}
 onChange={rulesetCustomPaymentPlanRulesetMinDownpaymentChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputCurrency
{...childProps}
  viewPath={`${viewPath}/TysiaInputCurrency`}
 placeholder="$0.00"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}